import Swiper, {Autoplay, EffectFade, Pagination} from 'swiper';
import { osHasReducedMotion } from '../util/a11y';

Swiper.use([Autoplay, EffectFade, Pagination]);

export default function() {
  Array.prototype.forEach.call( document.querySelectorAll('.js-swiper-vertical-tabs'), (el) => {

    let slides = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate):not(.swiper-slide-duplicate-prev)');
    let pagination = el.parentNode.querySelector('.swiper-pagination');
    let titles = [];

    // A11Y: Reduce Motion for Swiper Autoplay
    let autoplaySettings = osHasReducedMotion() ? {} : {
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    }

    Array.prototype.forEach.call( slides, (slide) => {
      titles.push(slide.dataset.title);
    });

    new Swiper(el, {
      slidesPerView: 1,
      direction: 'horizontal',
      centeredSlides: true,
      ...autoplaySettings,
      loop: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: pagination,
        bulletClass: 'sw-pagi-bullet',
        bulletActiveClass: 'sw-pagi-bullet-active',
        clickable: true,
        type: 'bullets',
        bulletElement: 'li',
        renderBullet: (index, className) => {
          return (
            '<li class="' + className + '">' + titles[index] + '</li>'
          );
        },
      },
    })

  });
}
